import * as actions from '../actionTypes'

const initialState = { 
    value: false
}

export default function showDashboardPrompts(state = initialState, action) {

    switch(action.type) {

        case actions.SET_SHOW_DASHBOARD_PROMPTS: {

            return {
                ...state,
                value: action.payload.value
            }
        }

        default:
            return state
    }
}